const types = {
  FETCH_FLEET_LOAD_CONFIRMATION_DETAILS_START: 'FETCH_FLEET_LOAD_CONFIRMATION_DETAILS_START',
  FETCH_FLEET_LOAD_CONFIRMATION_DETAILS_SUCCESS: 'FETCH_FLEET_LOAD_CONFIRMATION_DETAILS_SUCCESS',
  FETCH_FLEET_LOAD_CONFIRMATION_DETAILS_FAILURE: 'FETCH_FLEET_LOAD_CONFIRMATION_DETAILS_FAILURE',
  INITIATE_FLEET_LOAD_CONFIRMATION_PAYMENT_START: 'INITIATE_FLEET_LOAD_CONFIRMATION_PAYMENT_START',
  INITIATE_FLEET_LOAD_CONFIRMATION_PAYMENT_SUCCESS: 'INITIATE_FLEET_LOAD_CONFIRMATION_PAYMENT_SUCCESS',
  INITIATE_FLEET_LOAD_CONFIRMATION_PAYMENT_FAILURE: 'INITIATE_FLEET_LOAD_CONFIRMATION_PAYMENT_FAILURE',
  INITIATE_PAYMENT_STATUS_START: 'INITIATE_PAYMENT_STATUS_START',
  INITIATE_PAYMENT_STATUS_SUCCESS: 'INITIATE_PAYMENT_STATUS_SUCCESS',
  INITIATE_PAYMENT_STATUS_FAILURE: 'INITIATE_PAYMENT_STATUS_FAILURE',

  TOKEN_DETAIL: 'TOKEN_DETAIL',
  TOKEN_DETAIL_SUCCESS: 'TOKEN_DETAIL_SUCCESS',
  TOKEN_DETAIL_FAILURE: 'TOKEN_DETAIL_FAILURE',
  RESET_TOKEN_DETAIL: 'RESET_TOKEN_DETAIL',

  GET_BALANCE: 'GET_BALANCE',
  GET_BALANCE_SUCCESS: 'GET_BALANCE_SUCCESS',
  GET_BALANCE_FAILURE: 'GET_BALANCE_FAILURE',

  CONFIRM_DEMAND: 'CONFIRM_DEMAND',
  CONFIRM_DEMAND_SUCCESS: 'CONFIRM_DEMAND_SUCCESS',
  CONFIRM_DEMAND_FAILURE: 'CONFIRM_DEMAND_FAILURE',

  FETCH_CONTACT_INFO: 'FETCH_CONTACT_INFO',
  FETCH_CONTACT_INFO_SUCCESS: 'FETCH_CONTACT_INFO_SUCCESS',
  FETCH_CONTACT_INFO_FAILURE: 'FETCH_CONTACT_INFO_FAILURE',

  POST_COMPLETE_PAYMENT: 'POST_COMPLETE_PAYMENT',
  POST_COMPLETE_PAYMENT_SUCCESS: 'POST_COMPLETE_PAYMENT_SUCCESS',
  POST_COMPLETE_PAYMENT_FAILURE: 'POST_COMPLETE_PAYMENT_FAILURE',

  MP_APP_CONFIG: 'MP_APP_CONFIG',
  MP_APP_CONFIG_SUCCESS: 'MP_APP_CONFIG_SUCCESS',
  MP_APP_CONFIG_FAILURE: 'MP_APP_CONFIG_FAILURE',

  PAY_TOKEN: 'PAY_TOKEN',
  PAY_TOKEN_SUCCESS: 'PAY_TOKEN_SUCCESS',
  PAY_TOKEN_FAILURE: 'PAY_TOKEN_FAILURE',

  GET_VEHICLE_NUMBER_DETAIL_START: 'GET_VEHICLE_NUMBER_DETAIL_START',
  GET_VEHICLE_NUMBER_DETAIL_SUCCESS: 'GET_VEHICLE_NUMBER_DETAIL_SUCCESS',
  GET_VEHICLE_NUMBER_DETAIL_FAILURE: 'GET_VEHICLE_NUMBER_DETAIL_FAILURE',

  GET_VEHICLE_KYC_DETAIL_START: 'GET_VEHICLE_KYC_DETAIL_START',
  GET_VEHICLE_KYC_DETAIL_SUCCESS: 'GET_VEHICLE_KYC_DETAIL_SUCCESS',
  GET_VEHICLE_KYC_DETAIL_FAILURE: 'GET_VEHICLE_KYC_DETAIL_FAILURE',
  RESET_VEHICLE_KYC_DETAIL: 'RESET_VEHICLE_KYC_DETAIL',
};

export default types;
